import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=c7fb7ca2&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=c7fb7ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fb7ca2",
  null
  
)

export default component.exports